module.exports = __webpack_public_path__ + "static/media/ball.a5b6b88a.png";